import { DwQueryRequest } from '../views/CustomDashboards/types';
import { Filter } from './filter.types';

export type QueryOriginType = (typeof QueryOrigin)[keyof typeof QueryOrigin];

export const ErrorTypes = {
  AvContext: '[Context Error]',
  Setup: '[Setup Error]',
  Offline: '[Offline]',
  Network: '[Network Error]',
  Authentication: '[authentication Error]',
  Validation: '[validation Error]',
  APISIX: '[APISIX]',
  Generic: '[Error]',
  GraphQLSchema: '[GraphQL Schema]',
  Pendo: '[Pendo]',
};

export type AliasResolution = {
  fieldName: string;
  aliases: string[];
};

export type FeatureFlagsOverrides = {
  binnedTimeBuckets?: boolean;
};

export type Totals = {
  totalRow?: boolean;
  totalRowCount?: boolean;
};

export const FileFormat = {
  FILE_FORMAT_UNSPECIFIED: 'FILE_FORMAT_UNSPECIFIED',
  CSV_FORMAT: 'CSV_FORMAT',
  JSON_FORMAT: 'JSON_FORMAT',
  PDF_FORMAT: 'PDF_FORMAT',
  PNG_FORMAT: 'PNG_FORMAT',
  R360_JSON_FORMAT: 'R360_JSON_FORMAT',
  EXCEL_FORMAT: 'EXCEL_FORMAT',
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type FileFormat = (typeof FileFormat)[keyof typeof FileFormat];

export const QueryOrigin = {
  ORIGIN_UNSPECIFIED: 'ORIGIN_UNSPECIFIED',
  QUERY_RUNNER: 'QUERY_RUNNER',
  ETL: 'ETL',
  AGG_ENTITY: 'AGG_ENTITY',
  RAW_QUERY: 'RAW_QUERY',
  SCHEDULED_RULE: 'SCHEDULED_RULE',
  DATA_EXPLORATION: 'DATA_EXPLORATION',
  REPORT_QUERY: 'REPORT_QUERY',
  INTERACTIVE_QUERY: 'INTERACTIVE_QUERY',
  LOOKUP_QUERY: 'LOOKUP_QUERY',
  API: 'API',
  DELETE_QUERY: 'DELETE_QUERY',
  OUTEGRATIONS: 'OUTEGRATIONS',
  MANUAL_EXPORT_QUERY: 'MANUAL_EXPORT_QUERY',
  AGING: 'AGING',
  CLUSTERING_QUERY: 'CLUSTERING_QUERY',
  RISK360_QUERY: 'RISK360_QUERY',
  EASM_INTEGRATIONS_QUERY: 'EASM_INTEGRATIONS_QUERY',
  ZFABRIC: 'ZFABRIC',
  FIELDS_POPULATION: 'FIELDS_POPULATION',
  EXECUTION_ENGINE: 'EXECUTION_ENGINE',
  ZINSIGHTS: 'ZINSIGHTS',
  OUTEGRATIONS_ATTACHMENT_AQL: 'OUTEGRATIONS_ATTACHMENT_AQL',
  CLOUDVIEW: 'CLOUDVIEW',
  PROGRAMMATIC_QUERY: 'PROGRAMMATIC_QUERY',
  OUTEGRATIONS_SCRIPT: 'OUTEGRATIONS_SCRIPT',
  ATTACHED_SOURCES: 'ATTACHED_SOURCES',
  IOT: 'IOT',
  AUTOMATIONS: 'AUTOMATIONS',
  CHATBOT: 'CHATBOT',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type QueryOrigin = (typeof QueryOrigin)[keyof typeof QueryOrigin];

export type QueryObjectRequest = {
  query: DwQueryRequest;
  origin: QueryOrigin;
  totals?: Totals;
  isCacheEnabled?: boolean;
  fileFormat?: FileFormat;
  contextFilter?: Filter;
  maxFileSize?: number;
  multipleFiles?: boolean;
  queryId?: string;
  aliasResolution?: AliasResolution[];
  tags?: string[];
  featureFlagsOverrides?: FeatureFlagsOverrides;
};
